module.exports = __webpack_public_path__ + "static/img/restart-en.da48bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bottom-vr/img/restart-en.png
// module id = pMac
// module chunks = 1